import { Component, OnInit } from '@angular/core';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { RouterLink } from '@angular/router';
import { CommonComponent } from '@components/common.component';
import { diningActions, selectDining } from '@redux/dining.effects';
import moment from 'moment/moment';
import { AsyncPipe, DatePipe, NgForOf, NgIf, TitleCasePipe } from '@angular/common';

@Component({
  selector: 'app-dining-dashboard',
  standalone: true,
  imports: [AccordionModule, RouterLink, AsyncPipe, NgForOf, TitleCasePipe, NgIf, DatePipe],
  templateUrl: './dining-dashboard.component.html',
  styles: ``,
})
export class DiningDashboardComponent extends CommonComponent implements OnInit {
  locations$ = this.store.select(selectDining.selectLocations);
  //
  ngOnInit(): void {
    const meta = {
      path: 'dining-kiosk/meal/get-by-user',
      page: 1,
      limit: 10,
      parameters: [
        {
          field: 'start',
          value: moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        },
        {
          field: 'end',
          value: moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
        },
        {
          field: 'userId',
          value: this.resident!.id,
        },
      ],
    };
    if (this.resident?.careType) {
      meta.parameters.push({
        field: 'careTypeIds[]',
        value: this.resident!.careType.id,
      });
    }
    this.store.dispatch(diningActions.meta({ meta }));
  }
}
